import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

/**
 * Premium Badge primitive.
 * - Pill silhouette (rounded-full) for a modern, distinct look
 * - Translucent borders to integrate with the Dark Premium surfaces
 * - Slightly tighter typography for an editorial feel
 */
const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold tracking-tightish transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background",
  {
    variants: {
      variant: {
        default:
          "border-white/10 bg-primary/15 text-primary-foreground hover:bg-primary/25",
        secondary:
          "border-white/10 bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-white/10 bg-destructive/20 text-destructive-foreground hover:bg-destructive/30",
        outline:
          "border-white/15 text-foreground bg-white/0 hover:bg-white/5",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
